import { BrowserModule } from '@angular/platform-browser';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ColorPickerModule } from 'ngx-color-picker';
import { AppRoutingModule } from './app-routing.module';
import { RootComponent } from './components/root/root.component';
import { NavbarComponent } from './components/embedded/navbar/navbar.component';
import { LoginComponent } from './components/login/login.component';
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { StartpageComponent } from './components/startpage/startpage.component';
import { QuillModule } from 'ngx-quill';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { ManageUserComponent } from './components/manage-user/manage-user.component';
import { ManageRolesComponent } from './components/manage-roles/manage-roles.component';
import { CurrencyPipe } from './pipes/currency.pipe';
import { ShopComponent } from './components/shop/shop.component';
import { DenyAccessComponent } from './components/diagnose/deny-access/deny-access.component';
import { AccessDeniedLogComponent } from './components/diagnose/access-denied-log/access-denied-log.component';
import { SolveAccessDeniedIssueComponent } from './components/diagnose/solve-access-denied-issue/solve-access-denied-issue.component';
import { ProductTreeComponent } from './components/product-tree/product-tree.component';
import { SumCurrencyPipe } from './pipes/sum-currency.pipe';
import { ManageSignatureComponent } from './components/manage-signature/manage-signature.component';
import { NextcloudDiagnoseComponent } from './components/diagnose/nextcloud-diagnose/nextcloud-diagnose.component';
import { DATE_FORMATS } from './globals';
import { SingleInputComponent } from './components/dialog-components/single-input/single-input.component';
import { CodeInputModule } from 'angular-code-input';
import { ShopStandaloneComponent } from './components/standalones/shop-standalone/shop-standalone.component';
import { ShopNavbarComponent } from './components/shop-components/shop-navbar/shop-navbar.component';
import { ShopCoreComponent } from './components/shop-components/shop-core/shop-core.component';
import { ProductTilePreviewComponent } from './components/previews/product-tile-preview/product-tile-preview.component';
import { ShopProductDropdownPreviewComponent } from './components/shop-components/shop-product-dropdown-preview/shop-product-dropdown-preview.component';
import { ShoppingCartOverviewComponent } from './components/dialog-components/shopping-cart-overview/shopping-cart-overview.component';
import { WidgetViewStandaloneComponent } from './components/widget/widget-view-standalone/widget-view-standalone.component';
import { WidgetComponent } from './components/widget/widget/widget.component';
import { WidgetInnerDirective } from './directives/widget-inner.directive';
import { UnknownTypeComponent } from './components/widget/widget-inner-components/unknown-type/unknown-type.component';
import { CalendarWidgetInnerComponent } from './components/widget/widget-inner-components/calendar-widget-inner/calendar-widget-inner.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction'; // a plugin
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { SelectCalendarViewComponent } from './components/dialog-components/select-calendar-view/select-calendar-view.component';
import { FileExplorerWidgetInnerComponent } from './components/widget/widget-inner-components/file-explorer-widget-inner/file-explorer-widget-inner.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { CustomerWidgetInnerComponent } from './components/widget/widget-inner-components/customer-widget-inner/customer-widget-inner.component';
import { SelectWidgettypeComponent } from './components/widget/select-widgettype/select-widgettype.component';
import { ContractWidgetInnerComponent } from './components/widget/widget-inner-components/contract-widget-inner/contract-widget-inner.component';
import { LocationWidgetInnerComponent } from './components/widget/widget-inner-components/location-widget-inner/location-widget-inner.component';
import { ContactpersonWidgetInnerComponent } from './components/widget/widget-inner-components/contactperson-widget-inner/contactperson-widget-inner.component';
import { IssueWidgetInnerComponent } from './components/widget/widget-inner-components/issue-widget-inner/issue-widget-inner.component';
import { OfferWidgetInnerComponent } from './components/widget/widget-inner-components/offer-widget-inner/offer-widget-inner.component';
import { AssignmentMailWidgetInnerComponent } from './components/widget/widget-inner-components/assignment-mail-widget-inner/assignment-mail-widget-inner.component';
import { IncidentMailWidgetInnerComponent } from './components/widget/widget-inner-components/incident-mail-widget-inner/incident-mail-widget-inner.component';
import { IFrameWidgetInnerComponent } from './components/widget/widget-inner-components/i-frame-widget-inner/i-frame-widget-inner.component';
import { ChartWidgetInnerComponent } from './components/widget/widget-inner-components/chart-widget-inner/chart-widget-inner.component';
import { ChartsModule } from 'ng2-charts';
import { WidgetMenuComponent } from './components/widget/widget-menu/widget-menu.component';
import { EditUserfilterComponent } from './components/edit/edit-userfilter/edit-userfilter.component';
import { SelectIconComponentComponent } from './components/embedded/select-icon-component/select-icon-component.component';
import { FilterStructurePreviewComponent } from './components/widget/filter-structure-preview/filter-structure-preview.component';
import { EditForeignDashboardStandaloneComponent } from './components/standalones/edit-foreign-dashboard-standalone/edit-foreign-dashboard-standalone.component';
import { SelectUserComponent } from './components/dialog-components/select-user/select-user.component';
import { UserPreviewComponent } from './components/previews/user-preview/user-preview.component';
import { DateAgoPipe } from './pipes/date-ago.pipe';
import { NotificationDialogComponent } from './components/dialog-components/notification-dialog/notification-dialog.component';
import { NotificationPreviewComponent } from './components/previews/notification-preview/notification-preview.component';
import { NotificationDetailsDialogComponent } from './components/notification-details-dialog/notification-details-dialog.component';
import { QuickAssistComponent } from './components/dialog-components/quick-assist/quick-assist.component';
import { IssueModule } from './lib/issue/issue.module';
import { SharedModule } from './lib/shared/shared.module';
import { ErrorModule } from './lib/error/error.module';
import { ContractModule } from './lib/contract/contract.module';
import { LocationModule } from './lib/location/location.module';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateModule } from '@angular/material-moment-adapter';
import { MailModule } from './lib/mail/mail.module';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { OfferModule } from './lib/offer/offer.module';
import { CustomerModule } from './lib/customer/customer.module';
import { AuthGuard } from './lib/shared/auth-guard';
import { FilterFormComponent } from './components/widget/filter-form/filter-form.component';
import { UserFilterDialogComponent } from './components/widget/user-filter-dialog/user-filter-dialog.component';
import { FilterConditionsFormComponent } from './components/widget/filter-conditions-form/filter-conditions-form.component';
import { ShareUserFilterFormComponent } from './components/widget/share-user-filter-form/share-user-filter-form.component';
import { NextcloudModule } from './lib/nextcloud/nextcloud.module';
import { NewsfeedModule } from './lib/newsfeed/newsfeed.module';
import { AdminGuard } from './lib/shared/admin-guard';

registerLocaleData(localeDe);

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
  listPlugin,
  timeGridPlugin
]);

@NgModule({
  declarations: [
    RootComponent,
    UserFilterDialogComponent,
    NavbarComponent,
    LoginComponent,
    StartpageComponent,
    PopUpComponent,
    ManageUserComponent,
    ManageRolesComponent,
    CurrencyPipe,
    ShopComponent,
    DenyAccessComponent,
    AccessDeniedLogComponent,
    SolveAccessDeniedIssueComponent,
    ProductTreeComponent,
    SumCurrencyPipe,
    ManageSignatureComponent,
    NextcloudDiagnoseComponent,
    SingleInputComponent,
    ShopStandaloneComponent,
    ShopNavbarComponent,
    ShopCoreComponent,
    ProductTilePreviewComponent,
    ShopProductDropdownPreviewComponent,
    ShoppingCartOverviewComponent,
    WidgetViewStandaloneComponent,
    WidgetComponent,
    WidgetInnerDirective,
    UnknownTypeComponent,
    CalendarWidgetInnerComponent,
    SelectCalendarViewComponent,
    FileExplorerWidgetInnerComponent,
    CustomerWidgetInnerComponent,
    SelectWidgettypeComponent,
    ContractWidgetInnerComponent,
    LocationWidgetInnerComponent,
    ContactpersonWidgetInnerComponent,
    IssueWidgetInnerComponent,
    OfferWidgetInnerComponent,
    AssignmentMailWidgetInnerComponent,
    IncidentMailWidgetInnerComponent,
    IFrameWidgetInnerComponent,
    ChartWidgetInnerComponent,
    WidgetMenuComponent,
    EditUserfilterComponent,
    SelectIconComponentComponent,
    FilterStructurePreviewComponent,
    EditForeignDashboardStandaloneComponent,
    SelectUserComponent,
    UserPreviewComponent,
    DateAgoPipe,
    NotificationDialogComponent,
    NotificationPreviewComponent,
    NotificationDetailsDialogComponent,
    QuickAssistComponent,
    FilterFormComponent,
    FilterConditionsFormComponent,
    ShareUserFilterFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    OfferModule,
    ColorPickerModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatToolbarModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    CustomerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MomentDateModule,
    MatAutocompleteModule,
    MatSelectFilterModule,
    MatCheckboxModule,
    MatStepperModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    CodeInputModule,
    MatTreeModule,
    FullCalendarModule,
    AngularDraggableModule,
    QuillModule.forRoot(),
    ChartsModule,
    IssueModule,
    SharedModule,
    ErrorModule,
    ContractModule,
    LocationModule,
    MailModule,
    NextcloudModule,
    NewsfeedModule
  ],
  providers: [
    AuthGuard,
    AdminGuard,
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    { provide: LOCALE_ID, useValue: 'de' },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {
        'useUtc': true
      }
    },
    { provide: APP_BASE_HREF, useValue: '/client' }
  ],
  bootstrap: [RootComponent]
})
export class AppModule { }
